module.exports = __webpack_public_path__ + "43462cf9e490b28b9e4aa248fb2860a1.jpg";